import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { translations, fontSizes } from "../translations";

const ExplainerModal = ({
  showExplainerModal,
  handleExplainerModalClose,
  siteLanguage,
}) => {
  const [explainerTitle, setExplainerTitle] = useState("");
  const [explainerDescription, setExplainerDescription] = useState("");
  const [explainerModalExample1, setExplainerModalExample1] = useState("");
  const [explainerModalExample2, setExplainerModalExample2] = useState("");
  const [explainerModalExample3, setExplainerModalExample3] = useState("");
  const [explainerUnderstandButton, setExplainerUnderstandButton] =
    useState("");
  const fontSize = fontSizes[siteLanguage] || "1rem";

  useEffect(() => {
    setExplainerTitle(translations[siteLanguage].explainerModalTitle);
    setExplainerDescription(
      translations[siteLanguage].explainerModalDescription
    );
    setExplainerModalExample1(
      translations[siteLanguage].explainerModalExample1
    );
    setExplainerModalExample2(
      translations[siteLanguage].explainerModalExample2
    );
    setExplainerModalExample3(
      translations[siteLanguage].explainerModalExample3
    );
    setExplainerUnderstandButton(
      translations[siteLanguage].explainerModalUnderstand
    );
  }, [siteLanguage]);
  return (
    <Modal
      open={showExplainerModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          borderRadius: "15px",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          // boxShadow: 24,
          p: 2,
          paddingBottom: 2,
          bgcolor: "#333", // Change to your preferred dark color
          color: "white", // Set text color to white
          width: "90%",
          "@media (min-width:600px)": {
            width: "40%",
            maxWidth: "500px",
          },
          display: "flex", // Added display: "flex"
          flexDirection: "column",
          justifyContent: "center", // Added justifyContent: "center"
        }}
      >
        <Typography
          textAlign="center"
          id="modal-modal-title"
          variant="h4"
          component="h2"
          marginBottom={2}
        >
          {explainerTitle}
        </Typography>
        <Typography
          textAlign="center"
          id="modal-modal-description"
          variant="body1"
          component="p"
          marginBottom={4}
          style={{ fontSize }}
        >
          {explainerDescription}
        </Typography>

        <Typography
          textAlign="center"
          variant="body1"
          marginBottom={2}
          style={{ fontSize, fontStyle: "italic", fontWeight: "bold" }}
        >
          {explainerModalExample1}
        </Typography>
        <Typography
          textAlign="center"
          variant="body1"
          marginBottom={2}
          style={{ fontSize, fontStyle: "italic", fontWeight: "bold" }}
        >
          {explainerModalExample2}
        </Typography>
        <Button
          sx={{ marginTop: "10px" }}
          onClick={() => handleExplainerModalClose()}
          variant="contained"
          color="primary"
          style={{
            textTransform: "capitalize",
            fontSize: "1rem",
            width: "70%",
            alignSelf: "center",
            fontSize,
          }}
        >
          {explainerUnderstandButton}
        </Button>
      </Box>
    </Modal>
  );
};

export default ExplainerModal;
